/* tps-src.js · first-party add-source stamp + QA self-exclusion (Hephaestus, 6 Oct 2026, EXP-0002).
   Field list and rules: ~/Downloads/tps-v6-port/HEPH-STAMP-2026-10-06.md (Antiphon / Aegis read that, not this).
   WHAT IT WRITES: Hidden cart attributes (counts of ten UI words). They travel to the order as note attributes and are offered by Shopify to subscribed web pixels; no pixel may read them (Antiphon C1, 6 Oct).
     _tps_src_<source> = count of successful adds from that UI (source from the fixed list below only)
     _tps_qa = "1" while the tps_qa cookie is set; then NO stamp is written at all
   It never records a product, variant, name, price, size or quantity, and it makes no request to any host
   but this storefront's own /cart.js and /cart/update.js. It listens; it never changes an add, the drawer,
   a string or a fence, and every failure is swallowed (measurement must never reach a shopper).
   Hooks (each fires only AFTER the add succeeded):
     tps:src            CustomEvent on document, detail = source  (board v2, search overlay, drawer rail, cards, recs,
                        attach = charcoal page "Add with it" row; home = home "Shisha pipes" strip cards;
                        potd = home "Product of the day"; 6 Oct tickets)
     tpsb:add-result    ok:true from snippets/tps-board-atc; source = closest [data-tps-src] on the form, else other
     variant:add        detail.source "pdpv9" = pdp (hardware PDP); any other emitter = other
   QA: load any page with ?tps_qa=1 (sets a 365 day first-party cookie); ?tps_qa=0 clears it. */
(function (d, w) {
  if (w.__tpsSrc) return; w.__tpsSrc = 1;
  /* F3 (release 1 gate, 7 Oct): + setup = the hardware PDP "Complete your setup" panel (assets/tps-setup.js). The drawer
     rail keeps its existing word drawer-rail. Same mechanism, a count only. */
  var OK = { 'board-grid': 1, 'board-dropdown': 1, pdp: 1, 'pdp-switcher': 1, search: 1, 'drawer-rail': 1, attach: 1, home: 1, potd: 1, setup: 1, other: 1 };
  var m = /[?&]tps_qa=([01])(?:&|$)/.exec(location.search);
  if (m) d.cookie = 'tps_qa=' + (m[1] === '1' ? '1; max-age=31536000' : '; max-age=0') + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  /* Aegis SEC-STAMP-03: strip the param once handled so it cannot be copied onward or reach analytics page URLs. */
  if (m && history.replaceState) { try { var u = new URL(location.href); u.searchParams.delete('tps_qa'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {} }
  var qa = /(?:^|;\s*)tps_qa=1(?:;|$)/.test(d.cookie);
  var pend = {}, n = 0, t = 0, busy = 0, cur = null;
  function post(a, keep) {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: !!keep,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) });
  }
  function sum(p) {
    var a = {}, k;
    for (k in p) a['_tps_src_' + k] = String((parseInt(cur['_tps_src_' + k], 10) || 0) + p[k]);
    return a;
  }
  function flush() {
    t = 0; if (busy) return;
    var p = pend; pend = {}; n = 0; busy = 1;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cur = (c && c.attributes) || {};
        if (qa) return (c && c.item_count && cur._tps_qa !== '1') ? post({ _tps_qa: '1' }) : 0;
        var a = sum(p);
        /* returns only when there is something to write */
        for (var k in a) return post(a).then(function (r) { if (!r.ok) throw 0; for (var j in a) cur[j] = a[j]; });
      })
      .catch(function () { if (!qa) for (var k in p) { pend[k] = (pend[k] || 0) + p[k]; } })
      .then(function () { busy = 0; if (n) sched(); });
  }
  function sched() { clearTimeout(t); t = setTimeout(flush, 800); }
  function hit(s) {
    if (typeof s !== 'string' || !Object.prototype.hasOwnProperty.call(OK, s)) s = 'other'; /* Aegis SEC-STAMP-01 */
    if (s === 'other' && /^\/search(\/|$)/.test(location.pathname)) s = 'search';   // any add on the results page is a search add
    if (!qa) pend[s] = (pend[s] || 0) + 1;
    n++; sched();
  }
  d.addEventListener('tps:src', function (e) { hit(e.detail); });
  d.addEventListener('tpsb:add-result', function (e) {
    if (!e.detail || !e.detail.ok) return;
    var h = e.target && e.target.closest && e.target.closest('[data-tps-src]');
    hit(h ? h.getAttribute('data-tps-src') : 'other');
  });
  d.addEventListener('variant:add', function (e) { hit(e.detail && e.detail.source === 'pdpv9' ? 'pdp' : 'other'); });
  /* Leaving inside the 800 ms window: best effort, and only when this page already read the live counts
     (a blind write could lower a count; an undercount is acceptable, a wrong count is not). */
  w.addEventListener('pagehide', function () {
    if (!t || qa || !cur) return;
    clearTimeout(t); t = 0; try { post(sum(pend), 1); } catch (e) {}
  });
  /* A QA browser flags a cart it already holds (e.g. one filled by a harness through /cart/add.js directly). */
  if (qa) sched();
})(document, window);
